import React from 'react';
import './index.scss';

import Alarm from './notice.svg';
import Error from './error.svg';
export default function Notice(props: { type: 'normal' | 'warning' | 'error'; text: string }) {
    return (
        <>
            {props.text ? (
                <div className={'notice ' + props.type}>
                    {props.type === 'warning' ? <Alarm /> : null}
                    {props.type === 'error' ? <Error /> : null}
                    <span className="notice__text">{props.text}</span>
                </div>
            ) : null}
        </>
    );
}
